import { IVehiclePassport } from '~/rage';
import { CharacterLicense, numWord } from '~/shared';
import signature from '../../assets/images/signature.svg';
import { TextLabel } from '../TextLabel';
import { licenseCategories } from './Info.model';
import {
	StyledContainer,
	StyledDivider,
	StyledTable,
	StyledTableRow,
} from './Info.styled';

const Info = ({ info }: { info?: IVehiclePassport | null }) => {
	return (
		<StyledContainer>
			<StyledTable style={{ marginTop: 34 }}>
				<StyledTableRow>
					<TextLabel>Марка</TextLabel>
					<TextLabel $fw={500}>{info?.brandName}</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Модель</TextLabel>
					<TextLabel $fw={500}>{info?.modelName}</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Кузов т/с</TextLabel>
					<TextLabel $fw={500}>{info?.bodyType}</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Номер кузова</TextLabel>
					<TextLabel $fw={500}>{info?.vinNumber}</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Категория</TextLabel>
					<TextLabel>
						<span>
							{
								licenseCategories[
									info?.licenseCategory || CharacterLicense.DrivingCar
								].letter
							}
						</span>
						&nbsp;
						<span style={{ opacity: 0.5 }}>
							(
							{
								licenseCategories[
									info?.licenseCategory || CharacterLicense.DrivingCar
								].name
							}
							)
						</span>
					</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Кол-во владельцев</TextLabel>
					<TextLabel>
						<span>{info?.ownersCount}</span>&nbsp;
						<span style={{ opacity: 0.5 }}>
							{numWord(info?.ownersCount || 0, [
								'Владелец',
								'Владельца',
								'Владельцев',
							])}
						</span>
					</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Мощность ТС</TextLabel>
					<TextLabel>
						<span>{info?.enginePower}</span>&nbsp;
						<span style={{ opacity: 0.5 }}>л/с</span>
					</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Регистрация</TextLabel>
					<TextLabel $fw={500}>{info?.registryCityName}</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Владелец</TextLabel>
					<TextLabel $fw={500}>{info?.ownerNickname}</TextLabel>
				</StyledTableRow>
			</StyledTable>
			<StyledDivider />
			<StyledTable>
				<StyledTableRow>
					<TextLabel>Проверка</TextLabel>
					<TextLabel $fw={500}>{info?.registryPlaceName}</TextLabel>
				</StyledTableRow>
				<StyledTableRow>
					<TextLabel>Подпись шерифа</TextLabel>
					<img src={signature} />
				</StyledTableRow>
			</StyledTable>
		</StyledContainer>
	);
};

export { Info };
